import root from 'window-or-global';
import qs from 'query-string';

/**
 * gets a query variable from the given url or window.location
 * @param {string} name - query param name
 * @param {string} [url=window.location.href] - url to search
 * @returns {string|null}
 */
export const getParameterByName = function getParameterByName(name, url) {
    const windowLocation = url ? url : root.location.href;
    // NOTE: this regex is to remove brackets and brackets with indexes from the param name
    // DEVNOTE: probably not needed but seemed to to be what was in the original version of this method
    // @example "orders[]" -> "orders" and "orders[1]" -> "orders"
    // eslint-disable-next-line no-useless-escape
    const paramName = name.replace(/[\[\d*\]]/g, '');
    if (!windowLocation) {
        return null;
    }
    const queryString = qs.extract(windowLocation);
    const parsed = qs.parse(queryString);
    if (!parsed[paramName] && windowLocation.includes(`${name}=`)) {
        return '';
    }
    return parsed[paramName] || null;
};

/**
 * Get an array query variable from the given url or window.location
 * NOTE: does the same as getParameterByName only always returns an array
 * @param {string} name - query param name
 * @param {string} [url=window.location.href] - url to search
 * @returns {array}
 */
export const getParameterListByName = function getParameterListByName(name, url) {
    const result = getParameterByName(name, url);
    if (!result) {
        return [];
    }
    return Array.isArray(result) ? result : [result];
};

export const getBaseUrl = () => {
    const baseUrl = root.purchaseBaseUrl || root.appContext || '/';
    try {
        return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    } catch (e) {
        return baseUrl.lastIndexOf('/') === baseUrl.length - 1 ? baseUrl : `${baseUrl}/`;
    }
};

/**
 * Takes any hash params from window.location and appends them to the given url
 * NOTE: as a side effect, this also updates window.history
 * @param {string} url
 * @returns {string}
 */
export const appendLocationHashToUrl = (url) => {
    const locationHash = root.location.hash || '';
    if (locationHash) {
        root.history.replaceState({}, root.document.title, root.location.href.split('#')[0]);
        return `${url}${locationHash}`;
    }
    return url;
};
